<app-view-title Title="Vart vill du hämta släpet?" [overlay]="true"></app-view-title>
<location-map #map mode="Pickup" [locations]="locations" [(selectedLocation)]="selectedLocation" (locationConfirmed)="selectLocation()" [useCluster]="false"></location-map>

<view-actions>
  <h6>{{'Intellitrailer_ReturnLocation_lblSelectPickupLocation' | translate: 'Select pickup location'}}</h6>
</view-actions>

